import React, {FC} from "react"
import {RadialBarChart, RadialBar} from "recharts"

import {Body, H1, Label} from "@irati/ui/src/Typography"
import theme from "@irati/ui/src/global/theme"

import {RadialWrapper} from "../RadialPercentage/styled"
import {Step} from "./styled"

interface Props {
  completed: number,
  steps: number,
  fill: string,
  small?: boolean,
  extraSmall?: boolean,
  hideLabel?: boolean
}
const RadialSteps: FC<Props> = ({completed, steps, fill, small, extraSmall, hideLabel}) => {
  const getSize = () => {
    if (small)
      return 65
    if (extraSmall)
      return 40
    else
      return 115
  }

  const getRadius = () => {
    if (small)
      return "60%"
    if (extraSmall)
      return "45%"
    else
      return "70%"
  }

  const buildData = () => {
    const value = 100 * completed / steps
    return [
      {
        uv: 100,
        fill
      },
      {
        uv: value,
        fill: theme.colors.filterChip
      }
    ]
  }

  return (
    <RadialWrapper>
      <RadialBarChart
        width={getSize()}
        height={getSize()}
        innerRadius={getRadius()}
        outerRadius="100%"
        data={buildData()}
        startAngle={90}
        endAngle={-270}>
        <RadialBar background={{fill: theme.colors.greys.mediumLight}} clockWise dataKey='uv' cornerRadius={0} />
      </RadialBarChart>
      {!hideLabel &&
        <Step>
          {!small ? <>
            <H1 color={theme.colors.filterChip}>{completed}</H1>
            <Body color={theme.colors.filterChip}>/{steps}</Body>
          </> : <>
            <Label large color={theme.colors.filterChip}>{completed}</Label>
            <Label color={theme.colors.filterChip}>/{steps}</Label>
          </>}
        </Step>
      }
    </RadialWrapper>
  )
}

export default RadialSteps
